// extracted by mini-css-extract-plugin
export var alignCenter = "_6j-d";
export var bannerShown = "_6j-6";
export var buttonContent = "_6j-0";
export var cardList = "_6j-1";
export var centerContent = "_6j-2";
export var chevron = "_6j-3";
export var closePanelButton = "_6j-k";
export var conversationContextContainer = "_6j-l";
export var conversationDetailContainer = "_6j-4";
export var detailWrapper = "_6j-7";
export var dropdownButton = "_6j-e";
export var dropdownTitle = "_6j-9";
export var fullHeight = "_6j-5";
export var hidden = "_6j-a";
export var icon = "_6j-b";
export var mergeSuggestionWrapper = "_6j-m";
export var panel = "_6j-i";
export var portalButtonsWrapper = "_6j-c";
export var right = "_6j-j";
export var tableSummaryContainer = "_6j-8";
export var tableSummaryHeader = "_6j-g";
export var threeDotsButton = "_6j-f";
export var wide = "_6j-h";